import React from 'react';
import { useLocation } from 'react-router-dom';

export const detailsPageHashRegex = /details\/.*\/(\d+)/;
export const createPageHashRegex = /create\/(\d+)/;

// Normally, the hash is provided with a route change after the dx-object is modified,
// the component then loads the dx object based on the hash in its prop from redux.
// To emulate this behavior in storybook and jest, this HashProvider adds the hash from the pathname to the components prop
export const HashProvider = ({
  hashRegex,
  children,
}: {
  hashRegex: RegExp;
  children: React.ReactElement;
}) => {
  const { pathname } = useLocation();

  return (
    <>
      {React.cloneElement(children, {
        hash: pathname.match(hashRegex) ? pathname.match(hashRegex)![1] : '',
      })}
    </>
  );
};
